export default __webpack_public_path__ + "static/media/back.41b185a6.png";